import { createFileRoute } from '@tanstack/react-router';

import { DocumentCenter } from '~/features/leadDetails/components/Overview/DocumentCenter';

export const Route = createFileRoute('/_app/leads_/details/$leadId/document-center')({
    component: DocumentCenter,
});
